export default "__VITE_ASSET__BpjRf$Kz__"